import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Ana Sayfa", href: "/" },
    { name: "Hizmetler", href: "/hizmetler" },
    { name: "Hakkımızda", href: "/hakkimizda" },
    { name: "İletişim", href: "/iletisim" },
  ];

  const services = [
    { name: "Web Sitesi Kurulumu", href: "/hizmetler" },
    { name: "Google Ads Yönetimi", href: "/hizmetler" },
    { name: "SEO Optimizasyonu", href: "/hizmetler" },
    { name: "Sosyal Medya", href: "/hizmetler" },
  ];

  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link
              to="/"
              className="text-2xl font-bold font-['Outfit'] tracking-tight inline-block mb-4"
              data-testid="footer-logo"
            >
              <span className="text-purple-600">Roi</span> Bilişim
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              ROI odaklı dijital pazarlama çözümleri ile işletmenizi büyütüyoruz.
              Web sitesi ve Google Ads ile müşterilerinize ulaşın.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 font-['Outfit']">Hızlı Linkler</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 font-['Outfit']">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.name}>
                  <Link
                    to={service.href}
                    className="text-slate-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 font-['Outfit']">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone size={16} className="text-purple-400" />
                <a href="tel:+905413598024" className="hover:text-white transition-colors">
                  0541 359 80 24
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail size={16} className="text-purple-400" />
                <a href="mailto:info@dijitalyukselis.com" className="hover:text-white transition-colors">
                  info@dijitalyukselis.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin size={16} className="text-purple-400 mt-0.5" />
                <span>Türkiye</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} Roi Bilişim. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
              Gizlilik Politikası
            </a>
            <a href="#" className="text-slate-400 hover:text-white text-sm transition-colors">
              Kullanım Şartları
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
